var map = {
	"./feature_buy_en.png": 74959,
	"./feature_buy_id.png": 91794,
	"./feature_buy_ph.png": 84497,
	"./feature_buy_th.png": 1957,
	"./feature_buy_zh.png": 93807
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 52038;